import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation, HostListener, ChangeDetectorRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { Service } from "../../models/service";
import { RoleControllerService } from "../../services/role-controller/role-controller.service";
import { Store } from "../../services/store.service";
import { ServicePropertiesControllerService } from "../../services/service-controller/service-properties-controller.service";
import { GuideFormControllerService } from "../../services/form-controller/guide-form-controller.service";
import { ApplicantFormControllerService } from "../../services/form-controller/applicant-form-controller.service";
import { PaymentFormControllerService } from "../../services/form-controller/payment-form-controller.service";
import { SendFileFormControllerService } from "../../services/form-controller/sendfile-form-controller.service";
import { FormControllerService } from "../../services/form-controller/form-controller.service";
import { ServiceProperties } from "../../models/service-properties";
import { BaseError } from "../pages/base-error";
import {
  SystemPropertiesControllerService,
} from "../../services/system-settings/system-properties-controller.service";
import { ApplicationFileFormsContainer } from "../pages/application-file/forms-container";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LanguageControllerService } from "../../services/language-controller/language-controller.service";
import { WebsocketService } from "../../services/websocket.service";
import { SystemProperties } from "../../models/system-properties";
import { TranslatedBaseError } from "../pages/TranslatedBaseError";
import { Language } from "../../models/language";
import { MonitoringControllerService } from "src/app/services/monitoring-controller/monitoring-controller.service";
import { ServiceControllerService } from "../../services/service-controller/service-controller.service";
import { ExternalServerControllerService } from "../../services/service-controller/external-server-controller.service";
import { ExternalServer } from "../../models/external-server";
import { MappingService } from "../../services/mapping.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],

  providers: [RoleControllerService,
    FormControllerService,
    ServicePropertiesControllerService,
    GuideFormControllerService,
    ApplicantFormControllerService,
    PaymentFormControllerService,
    SendFileFormControllerService,
    ToastrService,
  ],
})
export class SidenavComponent extends TranslatedBaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public serviceName: string;
  @Input() public defaultMyAccountServiceId: string;
  @Input() public userName: string = "";
  @Input() public userEmail: string = "";
  @Input() public userInitial: string = "";
  @Input() public logout: () => Promise<void> | boolean;
  @Input() public systemProperties: any = { value: new SystemProperties() };

  public isCollapsed: boolean = true;
  public isTablesCollapsed: boolean = true;
  public isCrossTablesCollapsed: boolean = true;
  public isRegistrationCollapsed: boolean = true;
  public isRolesCollapsed: boolean = true;
  public isServicesCollapsed: boolean = true;
  public isApplicationCollapsed: boolean = true;

  public applicationFileData: any[];
  public tablesData: any[];
  public templatesData: any[];
  public crossedTablesData: any[];
  public registrationData: any[];
  public rolesData: any[];
  public botsData: any[];
  public settingsData: any[];
  public newService: Service = new Service();
  public services: Service[];

  public isApplicationFileSection: boolean;
  public isTablesSection: boolean;
  public isTemplatesSection: boolean;
  public isCrossedTablesSection: boolean;
  public isRegistrationSection: boolean;
  public isRolesSection: boolean;
  public isServicesSection: boolean;
  public isBotsSection: boolean;
  public isSettingsSection: boolean;
  public homelink: string;
  public applicationFilePage: string;
  public guideActive: boolean = false;
  public guideFormActive: boolean = false;
  public formActive: boolean = false;
  public paymentActive: boolean = false;
  public sendFileActive: boolean = false;
  public scrollVisible: boolean = false;
  public allForms: any[];
  // hack - angular does not support routerlinks properly

  public isLocal: boolean = environment.LOCAL;
  public env: any = environment;
  public beVersion: string = "1.0.0";
  public feVersion: string = "1.0.0";
  public dsBeVersion: string = "1.0.0";
  public dsFeVersion: string = "1.0.0";
  public gUp: number = 1;
  public beUp: boolean = true;
  public feUp: boolean = true;
  public dsBeUp: boolean = true;
  public dsFeUp: boolean = true;
  public usersOnCurrentPage: string = "";
  public currentlyLoggedInUsers: string = "";
  public connectedUsers: any[] = [];
  public systemUsers: any[] = [];
  public urlsToUsers: any[] = [];
  public pageOwner: any;

  public bpaDeploy: any = { systemId: "bpa_client" };

  private subscription: Subscription;
  public currentlyLoggedInCount: number = 1;
  public currentOnPageUsersCount: number = 0;
  private languages: Language[];
  public langIsRTL: boolean = false;
  public formId: boolean = false;

  public askingForPage: boolean = false;
  public askForPage: boolean = false;
  public pageAccessRequested: boolean = false;
  public pageAccessDenied: boolean = false;
  public showPageRequest: boolean = false;
  public askingUser: string = "-";
  public foundDrawer: boolean = true;

  public counter: number = 30;

  public userResponseTimeout: any;
  public inactiveUserTimeOut: any;
  public counterTimeOut: any;
  public static feMonitor;

  public serviceSavedName: string;
  public externalServers: ExternalServer[] = [];

  @ViewChild("stickySidenav")
  public stickySidenav: ElementRef;

  constructor(private router: Router,
    public store: Store,
    private formControllerService: FormControllerService,
    private servicePropertiesControllerService: ServicePropertiesControllerService,
    private systemPropertiesControllerService: SystemPropertiesControllerService,
    private activatedRoute: ActivatedRoute,
    private monitoringControllerService: MonitoringControllerService,
    public translateService: TranslateService,
    private languageService: LanguageControllerService,
    private serviceControllerService: ServiceControllerService,
    private externalServerService: ExternalServerControllerService,
    private webSocket: WebsocketService,
    public mappingService: MappingService,
    private cdr: ChangeDetectorRef,
    toastr: ToastrService) {
    super(toastr, translateService);

    const defaultLang = this.translateService.currentLang || store.state.common.lang || this.translateService.getDefaultLang();
    translateService.setDefaultLang(defaultLang);
    languageService.getLanguages().subscribe(
      (data) => {
        this.languages = data;
        const supportedLangCodes = data.map((l) => l.code);
        translateService.langs = [];
        // @ts-ignore
        translateService._$supportedLangs = supportedLangCodes;
        translateService.addLangs(supportedLangCodes);
        let currentLangCode = defaultLang;
        if (!supportedLangCodes.includes(currentLangCode) && supportedLangCodes[0]) {
          const index = translateService.langs.indexOf(currentLangCode);
          currentLangCode = supportedLangCodes[0];
          translateService.setDefaultLang(currentLangCode);
          translateService.store.defaultLang = currentLangCode;
          this.changeLanguage(currentLangCode);
          store.state.common.lang = currentLangCode;
          if (index !== -1) {
            translateService.langs.splice(index, 1);
          }
        } else {
          this.checkRtlHTML();
        }
      });
    this.setupCurrentlyLoggedUsers(null);
  }

  private async checkRtlHTML() {
    const currentLangCode = this.translateService.currentLang || this.translateService.getDefaultLang();
    let currentLanguage = this.languages.find((l) => l.code === currentLangCode);
    if (!currentLanguage) {
      this.languages = await this.languageService.getLanguages().toPromise();
      currentLanguage = this.languages.find((l) => l.code === currentLangCode);
    }
    if (currentLanguage && currentLanguage.rtllanguage) {
      window.document.dir = "rtl";
      this.langIsRTL = true;
    } else {
      window.document.dir = undefined;
      this.langIsRTL = false;
    }
  }

  public containsUrl(coll: any[], url: string) {
    return coll.some((it) => url.includes(it.link));
  }

  public closeLevel2() {
    this.isCollapsed = true;
  }

  public isScrollVisible(elem) {
    if (elem) {
      this.scrollVisible = elem.scrollHeight > elem.clientHeight;
    }
  }

  public getMAServices() {
    this.serviceControllerService.getMyAccountService().subscribe((data) => {
      this.defaultMyAccountServiceId = data.id;
      this.store.state.common.defaultMyAccountServiceId = this.defaultMyAccountServiceId;
    });
  }

  public toggleSideBar() {
    this.store.state.common.sidemenuSmall = !this.store.state.common.sidemenuSmall;
    this.mappingService.refresh();
    this.setSidebarState();
  }

  public setSidebarState() {
    const barstate = this.store.state.common.sidemenuSmall;
    if (barstate === true) {
      document.body.classList.add("sidebar-is-collapsed");
      document.body.classList.remove("sidebar-is-expanded");
    } else {
      document.body.classList.remove("sidebar-is-collapsed");
      document.body.classList.add("sidebar-is-expanded");
    }
  }

  public resetCollapsed() {
    this.isServicesCollapsed = true;
    this.isTablesCollapsed = true;
    this.isCrossTablesCollapsed = true;
    this.isRegistrationCollapsed = true;
    this.isRolesCollapsed = true;
    this.isApplicationCollapsed = true;
    this.isCollapsed = true;
  }

  public toggleServices() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isServicesCollapsed = false;
  }

  public toggleTablesCollapsed() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isTablesCollapsed = false;
  }

  public toggleCrossTablesCollapsed() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isCrossTablesCollapsed = false;
  }

  public toggleRegistrationCollapsed() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isRegistrationCollapsed = false;
  }

  public toggleRolesCollapsed() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isRolesCollapsed = false;
  }

  public toggleApplicationCollapsed() {
    this.resetCollapsed();
    this.isCollapsed = false;
    this.isApplicationCollapsed = false;
  }

  private init() {
    this.registrationData = [];
    this.rolesData = [];
    this.botsData = [];
    this.applicationFileData = [
      { link: `/services/${this.serviceId}/guides`, translation: "nav.2_1_guide", name: "Guide" },
      { link: `/services/${this.serviceId}/forms/guide-form`, translation: "nav.2_1_guide_form", name: "GuideForm" },
      { link: `/services/${this.serviceId}/forms/applicant`, translation: "nav.2_2_form", name: "" },
      { link: `/services/${this.serviceId}/forms/applicant-form`, translation: "nav.2_2_form", name: "" },
      { link: `/services/${this.serviceId || this.defaultMyAccountServiceId}/forms/applicant-form`, translation: "nav.2_2_form_new", name: "ApplicantForm" },
      { link: `/services/${this.serviceId}/forms/document-form`, translation: "nav.2_3_docs", name: "DocumentForm" },
      { link: `/services/${this.serviceId}/forms/payment`, translation: "nav.2_5_payment", name: "PaymentForm" },
      { link: `/services/${this.serviceId}/forms/sendfile`, translation: "nav.2_5_send", name: "SendPageForm" },
    ];
    this.tablesData = [
      { link: `/services/${this.serviceId}/determinantstable`, translation: "nav.annexes-determinants" },
      { link: `/services/${this.serviceId}/documentstable`, translation: "nav.annexes.documents" },
      { link: `/services/${this.serviceId}/coststable`, translation: "nav.annexes.costs" },
      { link: `/services/${this.serviceId}/institutionstable`, translation: "nav.annexes.inst" },
      { link: `/services/${this.serviceId}/fieldstable`, translation: "nav.annexes.fields" },
      { link: `/services/${this.serviceId}/notification`, translation: "nav.guide_messages" },
      // { link: `/translations/${this.serviceId}`, translation: "nav.translations" },
      { link: `/services/${this.serviceId}/lawstable`, translation: "nav.annexes.laws" },
      { link: `/services/${this.serviceId}/locationstable`, translation: "nav.annexes.collection-place" },
      { link: `/services/${this.serviceId}/fieldgeneratortable`, translation: "nav.annexes.fieldgen" },

    ];
    this.templatesData = [
      { link: `/services/${this.serviceId}/templates`, translation: "Templates" },
      { link: `/services/${this.serviceId}/messagestable`, translation: "Templates" },
      { link: `/services/${this.serviceId}/print-documents`, translation: "Templates" },
    ];
    this.crossedTablesData = [
      { link: `/services/${this.serviceId}/costreg`, translation: "nav.annexes.tables.costs_regis" },
      { link: `/services/${this.serviceId}/docsreg`, translation: "nav.annexes.tables.docs_regis" },
      { link: `/services/${this.serviceId}/detreg`, translation: "nav.annexes.tables.dets_regis" },
      { link: `/services/${this.serviceId}/formfieldsreg`, translation: "nav.annexes.tables.formfields_regis" },
      { link: `/services/${this.serviceId}/instreg`, translation: "nav.annexes.tables.inst_regis" },
      { link: `/services/${this.serviceId}/rolereg`, translation: "nav.annexes.tables.roles_regis" },
      { link: `/services/${this.serviceId}/fieldsProps`, translation: "nav.annexes.tables.fields_props" },
      { link: `/services/${this.serviceId}/servicelocreg`, translation: "nav.annexes.tables.service_locations_regis" },
    ];
    this.settingsData = [
      { link: `/translate`, translation: "header.manage_translation" },
      { link: `/settings`, translation: "Instance settings" },
    ];
    this.chooseSectionByUrlAndRevealIt();
    this.loadApplicationFilePage();
    this.setSidebarState();
  }

  private chooseSectionByUrlAndRevealIt() {
    const url = this.router.url;
    if (this.containsUrl(this.applicationFileData, url) || url.endsWith(`/services/${this.serviceId}/forms/applicant-form`)) {
      this.isApplicationFileSection = true;
      // this.isCollapsed = false;
    }

    if (this.containsUrl(this.tablesData, url)) {
      this.isTablesSection = true;
      // this.isTablesCollapsed = false;
    }

    if (this.containsUrl(this.templatesData, url)) {
      this.isTemplatesSection = true;
      // this.isTablesCollapsed = false;
    }

    if (this.containsUrl(this.crossedTablesData, url)) {
      this.isCrossedTablesSection = true;
      // this.isCrossTablesCollapsed = false;
    }

    if (this.containsUrl(this.registrationData, url) || url.endsWith(`/services/${this.serviceId}/registrations`)) {
      this.isRegistrationSection = true;
      // this.isRegistrationCollapsed = false;
    }

    if (this.containsUrl(this.rolesData, url) || url.endsWith(`/services/${this.serviceId}/roles`)) {
      this.isRolesSection = true;
      // this.isRolesCollapsed = false;
    }

    if (this.containsUrl(this.botsData, url) || url.endsWith(`/services/${this.serviceId}/bots`) || url.includes(`/services/${this.serviceId}/actions`)) {
      this.isBotsSection = true;
      // this.isRolesCollapsed = false;
    }

    if (this.containsUrl(this.settingsData, url)) {
      this.isSettingsSection = true;
    }

    if (url.endsWith("/services") || url === "/") {
      this.isServicesSection = true;
      // this.isCrossTablesCollapsed = false;
    }
  }

  private loadApplicationFilePage() {
    if (this.serviceId || this.defaultMyAccountServiceId) {
      this.loadForm();
    }
  }

  public static formatForm(name: string): string {
    switch (name) {
      case "GUIDE":
        return ApplicationFileFormsContainer.formPaths[0];
      case "PAYMENT PAGE":
      case "PAYMENT":
        return ApplicationFileFormsContainer.formPaths[3];
      case "SEND PAGE":
      case "SENDPAGE":
        return ApplicationFileFormsContainer.formPaths[4];
      case "FORM PAGE":
      case "DOCUMENT":
        return ApplicationFileFormsContainer.formPaths[2];
      default:
      case "APPLICANT":
      case "APPLICANTFORM":
        return ApplicationFileFormsContainer.formPaths[1];
    }
  }

  private loadForm(): void {
    this.applicationFilePage = "applicant-form";
    this.servicePropertiesControllerService.getServiceProperties(this.serviceId || this.defaultMyAccountServiceId).subscribe(
      (props: ServiceProperties) => {
        this.guideActive = props.oldGuideActive;
        if (this.guideActive) {
          if (!this.applicationFilePage) {
            this.applicationFilePage = "guides";

            this.formControllerService.getAllFormStatuses(this.serviceId || this.defaultMyAccountServiceId).subscribe(
              (data) => {
                for (const form of data) {
                  if (form.active) {
                    this.applicationFilePage = SidenavComponent.formatForm(form.name);
                    break;
                  }
                }
              },
            );
          }
        }
      },
    );
  }

  public getBuildColor() {
    if (this.env && this.env.BUILD_TYPE) {
      switch (this.env.BUILD_TYPE.toLowerCase()) {
        case "draft":
          return "border-draft";
        case "dev":
          return "border-dev";
        case "beta":
          return "border-beta";
        case "rc":
          return "border-rc";
        case "live":
          return "border-live";
        case "prelive":
          return "border-prelive";
        default:
          return "border-secondary";
      }
    } else {
      return "bg-light";
    }
  }

  public getBuildIcon() {
    if (this.env && this.env.BUILD_TYPE) {
      switch (this.env.BUILD_TYPE.toLowerCase()) {
        case "dev":
          return "fa-code";
          break;
        case "beta":
          return "fa-flask-gear";
          break;
        case "rc":
          return "fa-badge-check";
          break;
        case "live":
          return "fa-globe";
          break;
        default:
          return "fa-code";
          break;
      }
    } else {
      return "fa-code";
    }
  }

  public requestPageAccess() {
    this.askingForPage = true;
    this.showPageRequest = false;
    this.initCounter();
    const currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
    this.webSocket.requestPageAccess(this.userName, currentPath);
  }

  public acceptPageRequest() {
    clearTimeout(this.userResponseTimeout);
    clearInterval(this.counterTimeOut);
    this.pageAccessRequested = false;
    const currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
    this.webSocket.acceptPageAccess(this.userName, currentPath);
    this.router.navigate(["/services/", { backFromForm: true }]);
  }

  public aknowledgePageDenied() {
    this.pageAccessDenied = false;
    this.askingForPage = false;
    const currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
    this.webSocket.aknowledgePageDenied(this.userName, currentPath);
  }

  public denyPageRequest() {
    clearTimeout(this.userResponseTimeout);
    clearInterval(this.counterTimeOut);
    this.pageAccessRequested = false;
    this.resetDrawer();
    const currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
    this.webSocket.denyPageAccess(this.userName, currentPath);
  }

  public dismissPageRequest() {
    clearInterval(this.counterTimeOut);
    this.askingForPage = false;
    const currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
    this.webSocket.dismissPageAccess(this.userName, currentPath);
  }

  public lookForDrawer() {
    const drawer = document.querySelectorAll(".component-settings")[0];
    if (drawer) {
      this.foundDrawer = true;
      drawer.classList.add("hidden");
    }
  }

  public resetDrawer() {
    const drawer = document.querySelectorAll(".component-settings")[0];
    if (drawer) {
      this.foundDrawer = false;
      drawer.classList.remove("hidden");
    }
  }

  public monitorGeneralVersion() {
    if (!this.feUp || !this.beUp || !this.dsBeUp || (environment.USE_NEW_DS && !this.dsFeUp)) {
      this.gUp = 0;
    }
    if (!this.feUp && !this.beUp && !this.dsBeUp && (environment.USE_NEW_DS && !this.dsFeUp)) {
      this.gUp = -1;
    }
    if (this.feUp && this.beUp && this.dsBeUp && (environment.USE_NEW_DS && this.dsFeUp)) {
      this.gUp = 1;
    }
  }

  public setupCurrentlyLoggedUsers(users: any) {
    this.currentlyLoggedInUsers = users && Object.keys(users).map((key) => users[key]?.fullName).join(", ") || "";
    this.currentlyLoggedInCount = users && Object.keys(users).length || 1;
  }

  public loadSystemProperties() {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
      (systemProperties: any) => {
        if (systemProperties) {
          this.bpaDeploy = systemProperties.deployProperties.filter((p) => p.systemId === "bpa_client")[0];
          this.systemProperties.value = systemProperties;
          this.systemProperties.value.siteName = this.systemProperties.value.siteName || "dev";
          this.homelink = systemProperties.homepageUrl ? systemProperties.homepageUrl : environment.E_REGISTRATIONS_HOME_URL;
        }
      },
    );
  }

  public toggleDeployEnabled() {
    if (!this.bpaDeploy) {
      console.error("bpaDeploy is not defined");
      this.showErrorMessage({ message: "Deploy properties not loaded. Please refresh the page." });
      return;
    }

    // Get the actual system properties object (handle both wrapped and unwrapped cases)
    const sysProps = this.systemProperties?.value || this.systemProperties;

    if (!sysProps || !sysProps.deployProperties) {
      console.error("System properties or deployProperties is not defined", sysProps);
      this.showErrorMessage({ message: "System properties not loaded. Please refresh the page." });
      return;
    }

    // Store the current value before toggle
    const oldValue = this.bpaDeploy.deployEnabled;

    // Toggle the deployEnabled flag
    this.bpaDeploy.deployEnabled = !this.bpaDeploy.deployEnabled;

    // Also ensure the change is reflected in the systemProperties array
    const deployIndex = sysProps.deployProperties.findIndex((p) => p.systemId === "bpa_client");
    if (deployIndex !== -1) {
      sysProps.deployProperties[deployIndex].deployEnabled = this.bpaDeploy.deployEnabled;
    }

    // Manually trigger change detection to ensure the view updates
    this.cdr.detectChanges();

    // Call the update method
    this.updateSystemProps();
  }

  public updateSystemProps() {
    // Get the actual system properties object (handle both wrapped and unwrapped cases)
    const sysProps = this.systemProperties?.value || this.systemProperties;

    this.systemPropertiesControllerService.updateServiceProperties(sysProps).subscribe(
      (data) => {
        this.responseSuccessful("System properties updated");
      },
      (error) => {
        console.error("Failed to update system properties:", error);
        this.showErrorMessage(error);
      },
    );
  }

  private formatCurrentPageUsers(users, loggedInUsers): string {
    let usersInPage = "";
    if (users && users.length) {
      for (let u = 0; u < users.length; u++) {
        const fullName = loggedInUsers && loggedInUsers[users[u].username]?.fullName;
        usersInPage += (fullName || users[u].username || users[u].email) + " ";
      }
    }
    return usersInPage;
  }

  private getCurrentUserTabsNumber(username, users) {
    const nbUser = users.filter((u) => {
      return u.username === username;
    });
    return nbUser.length;
  }

  public formatUserName(usr) {
    const fullName = this.connectedUsers && this.connectedUsers[usr?.username]?.fullName;
    return (fullName || usr?.username || usr?.email || "unknown user");
  }

  private connectWebsocket() {
    let previousUser = "";
    this.subscription = this.webSocket.connect().subscribe(
      (message) => {
        try {
          if (message) {
            if (message.users) {
              this.setupCurrentlyLoggedUsers(message.users);
            }
            let currentPath = "/" + this.activatedRoute.snapshot.url.join("/");
            let index = currentPath.indexOf("#");
            if (index !== -1) {
              currentPath = currentPath.substring(0, index);
            }
            index = currentPath.indexOf("%23");
            if (index !== -1) {
              currentPath = currentPath.substring(0, index);
            }
            // console.log("--- currentPath", currentPath);
            if (message.urlsToUsers && message.urlsToUsers[currentPath]) {
              this.urlsToUsers = message.urlsToUsers[currentPath] || [];
              this.connectedUsers = message.users || [];
              this.systemUsers = Object.values(this.connectedUsers);
              // console.log(this.systemUsers);
              this.usersOnCurrentPage = this.formatCurrentPageUsers(this.urlsToUsers, message.users);
              this.currentOnPageUsersCount = this.urlsToUsers.length;
              this.pageOwner = this.urlsToUsers.find((u) => u.ownsPage);
              const currentUser = this.urlsToUsers.find((u) => u.connId === message.connId);
              if ((currentUser.connId !== this.pageOwner?.connId) && this.checkIfpageIsAskable()) {
                this.store.state.common.lockedPageByUser = true;
                this.askForPage = true;
                previousUser = this.pageOwner?.connId;
                if (currentUser.askedToLeaveDenied) {
                  this.pageAccessDenied = true;
                  this.askingForPage = false;
                }
                if (!this.askingForPage) {
                  this.showPageRequest = true;
                }
              } else {
                this.store.state.common.lockedPageByUser = false;
                this.askForPage = false;
                this.showPageRequest = false;
                if (currentUser.connId === this.pageOwner?.connId && this.pageOwner?.askedToLeaveBy) {
                  this.pageAccessRequested = true;
                  this.lookForDrawer();
                  this.initCounter();
                  this.forceUnrespondingUser();
                  this.askingUser = this.pageOwner?.askedToLeaveBy?.username;
                } else if (currentUser.connId === this.pageOwner?.connId && !(this.pageOwner?.askedToLeaveBy)) {
                  clearTimeout(this.userResponseTimeout);
                  clearInterval(this.counterTimeOut);
                  this.pageAccessRequested = false;
                  this.askingForPage = false;
                  this.askingUser = "-";
                }
                if (previousUser && previousUser !== currentUser.connId && this.formId) {
                  location.reload();
                }
              }
            }
            if (message.currentlyPublishedCount) {
              this.store.state.common.runningPublications = Number(message.currentlyPublishedCount);
            } else {
              this.store.state.common.runningPublications = 0;
            }
            this.store.state.common.lockPublishButton = message.publishes && this.serviceId && message.publishes[this.serviceId];
            if (message.publishes) {
              this.store.state.common.currentlyPublishingUsers = "";
              Object.entries(message.publishes).forEach(([key, value]) => {
                // @ts-ignore
                this.store.state.common.currentlyPublishingUsers += `<br>${value.serviceName} - ${value.userName.split("(")[0]}`;
              });
            }
            if (message.services) {
              if (message.services.bpaBe) {
                this.beUp = message.services.bpaBe.health;
                this.beVersion = message.services.bpaBe.version;
              }
              if (message.services.bpaFe) {
                this.feUp = message.services.bpaFe.health;
                this.feVersion = message.services.bpaFe.version;
              }
              if (message.services.dsBe) {
                this.dsBeUp = message.services.dsBe.health;
                this.dsBeVersion = message.services.dsBe.version;
              }
              if (message.services.dsFe) {
                this.dsFeUp = message.services.dsFe.health;
                this.dsFeVersion = message.services.dsFe.version;
              }
              this.monitorGeneralVersion();
            }
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.trace("websocket message processing failed", e);
          this.websocketConnectErrorCb();
        }
      },
      (err) => {
        // eslint-disable-next-line no-console
        console.trace("websocket connection broke", err);
        this.websocketConnectErrorCb();
      });
  }

  public websocketConnectErrorCb() {
    try {
      this.currentlyLoggedInCount = 1;
      this.currentlyLoggedInUsers = "";
      this.currentOnPageUsersCount = 0;

      this.askingForPage = false;
      this.askForPage = false;
      this.pageAccessRequested = false;
      this.pageAccessDenied = false;
      this.showPageRequest = false;
      this.askingUser = "-";
      this.usersOnCurrentPage = "";

      this.store.state.common.currentlyPublishingUsers = "";
      this.store.state.common.lockedPageByUser = false;
      this.store.state.common.lockPublishButton = false;
      this.store.state.common.runningPublications = 0;
      clearTimeout(this.userResponseTimeout);
      clearInterval(this.counterTimeOut);
      this.webSocket.closeConnection();
      // eslint-disable-next-line no-empty, @typescript-eslint/no-empty-function
    } catch (e) {
      // eslint-disable-next-line no-console
      console.trace("websocket error", e);
    }
    setTimeout(this.connectWebsocket.bind(this), 3000);
  }

  public monitorFe() {
    // reason for this monitoring to be here is for user not getting logged out while being on idle
    this.monitoringControllerService.getFEStatus().subscribe((data) => {
      this.feUp = (data && data.status && data.status === "up");
      SidenavComponent.feMonitor = setTimeout(() => this.monitorFe(), 60000);
    }, (error) => {
      this.feUp = false;
      SidenavComponent.feMonitor = setTimeout(() => this.monitorFe(), 60000);
    });
  }

  public checkIfpageIsAskable() {
    const loackablePaths = ["forms", "roles", "bots", "templates", "print-documents"];
    const currentPath = this.activatedRoute?.snapshot?.url[2]?.path;
    const isPath = loackablePaths.some((p) => {
      return p === currentPath;
    });
    // console.log("--- check Page askable", this.pageOwner, currentPath, this.activatedRoute.snapshot, this.activatedRoute.snapshot.url[3]?.path !== undefined, isPath, this.activatedRoute.snapshot.url[3]?.path !== undefined && isPath);
    return this.activatedRoute.snapshot.url[3]?.path !== undefined && isPath;
  }

  public ngOnInit() {
    this.loadSystemProperties();
    this.isScrollVisible(this.stickySidenav);
    this.init();
    this.toggleBar();
    this.loadExternalServers();
    if (!this.isLocal) {
      this.connectWebsocket();
      clearTimeout(SidenavComponent.feMonitor);
      this.monitorFe();
    }
    this.activatedRoute.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.formId = (params.formId || params.roleId || params.documentId) ? true : false;
      this.chooseSectionByUrlAndRevealIt();
      // to put back to check user inactivity
      /*
      if (this.formId) {
        this.checkTimeOut();
      }
      if (params.backFromForm && params.backFromForm === "true") {
        this.simpleErrorMessage("You've been redirect due to inactivity");
      }
      */
    });
    this.loadSystemProperties();
    setTimeout(() => {
      this.initLevelUser();
    });
    this.checkIfpageIsAskable();

    this.defaultMyAccountServiceId = this.store.state.common.defaultMyAccountServiceId;
    if (!this.defaultMyAccountServiceId) {
      this.getMAServices();
    }
  }

  public loadExternalServers() {
    this.externalServerService.getExternalServers().subscribe(
      (data: ExternalServer[]) => {
        this.externalServers = data;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public initLevelUser() {
    // eslint-disable-next-line
    if (this.store.state.common.userLevels.get("SideNavLevel") === false) {
      // eslint-disable-next-line
      this.store.state.common.userLevels.pages.SideNavLevel = 1;
    } else {
      // eslint-disable-next-line
      this.store.state.common.userLevels.pages.SideNavLevel = this.store.state.common.userLevels.get("SideNavLevel");
    }
  }

  public checkTimeOut() {
    this.inactiveUserTimeOut = setTimeout(() => {
      this.rerouteUser();
    }, 600000);
  }

  public forceUnrespondingUser() {
    this.userResponseTimeout = setTimeout(() => {
      this.acceptPageRequest();
    }, 30000);
  }

  public initCounter() {
    this.counter = 30;
    if (this.counterTimeOut) {
      clearInterval(this.counterTimeOut);
    }
    this.counterTimeOut = setInterval(() => {
      this.counter--;
      if (this.counter <= 0) {
        this.counter = 30;
        clearInterval(this.counterTimeOut);
      }
    }, 1000);
  }

  @HostListener("window:keydown")
  @HostListener("window:mousedown")
  @HostListener("window:mousemove")
  public checkUserActivity() {
    if (this.formId && this.inactiveUserTimeOut) {
      clearTimeout(this.inactiveUserTimeOut);
      this.checkTimeOut();
    }
  }

  public rerouteUser() {
    this.router.navigate(["/services/", { backFromForm: true }]);
  }

  public toggleBar() {
    const barstate = this.store.state.common.topBarCollapsed;
    if (barstate === true) {
      document.body.classList.add("topbar-is-collapsed");
      document.body.classList.remove("topbar-is-expanded");
    } else {
      document.body.classList.remove("topbar-is-collapsed");
      document.body.classList.add("topbar-is-expanded");
    }
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public changeLanguage(langCode: string) {
    this.translateService.use(langCode).subscribe(() => {
      this.store.state.common.lang = langCode;
      return this.checkRtlHTML();
    });
    return false;
  }

}
